import Logo from "@/components/common/Logo";

const PublicHeader = () => {
  return (
    <header className="bg-godyspo-dark border-b border-border">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Logo size="medium" context="buyer" />
          <nav className="flex items-center gap-4 md:gap-6">
            <a 
              href="/blog" 
              className="text-white hover:text-godyspo-gold transition-colors text-sm font-medium"
            >
              Blog
            </a>
            <a 
              href="/seller" 
              className="text-white hover:text-godyspo-gold transition-colors text-sm font-medium"
            >
              For Sellers
            </a>
            <a 
              href="/buyer" 
              className="text-white hover:text-godyspo-gold transition-colors text-sm font-medium"
            >
              For Buyers
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
